import template from './meredicte.html';
import './meredicte.styl';

function meredicteComponent($location, $anchorScroll) {

  'ngInject';

  this.scrollTo = (id) => {
    // set the location.hash to the id of
    // the element you wish to scroll to.
    $location.hash(id);

    // call $anchorScroll()
    $anchorScroll();
  };
}

export default {
  template,
  controller: meredicteComponent,
};



// WEBPACK FOOTER //
// ./src/containers/meredicte/index.js